import {
  Component,
  Input,
  OnInit,
  AfterViewInit,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { RendererOptions } from '@hi-level/2d-renderer';
import { QuoteData } from '@iqd/shared-quoting';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { Apollo } from 'apollo-angular';
import { Map } from 'immutable';
import { map, Observable } from 'rxjs';
import { AppState } from '../../app.module';
import { ContactDetailsModalComponent } from '../contact-details-modal/contact-details-modal.component';
import { RequestAccessModalComponent } from '../request-access-modal/request-access-modal.component';
import { updateBudgetQuote } from './budget-result.model';
import { Drawing, Renderer } from '@hi-level/3d-renderer';
import { ErrorModalComponent } from '@iqd/shared-utils';

@Component({
  selector: 'app-budget-result',
  templateUrl: './budget-result.component.html',
  styleUrls: ['./budget-result.component.scss'],
})
export class BudgetResultComponent implements OnInit, AfterViewInit {
  @Input() quoteData: QuoteData;
  @Input() drawing: any;
  @Input() backsheet: any;
  @Input() budgetQuoteId: number;

  budgetDisclaimer: Observable<string>;
  pricingHidden = true;
  private settings: Observable<Map<string, any>>;
  private phoneNumber: string;

  options: RendererOptions;
  activeTab = '3dModel';

  private renderer: any = null;
  @ViewChild('viewerContainer', { static: false }) viewerContainer!: ElementRef;

  constructor(
    private store: Store<AppState>,
    private modalService: NgbModal,
    private apollo: Apollo
  ) {
    this.settings = this.store.select(
      (state) => state.settings.currentSettings
    );
    this.budgetDisclaimer = this.getBudgetDisclaimer();
  }

  ngOnInit(): void {
    this.initializeRendererOptions();

    const modalRef = this.modalService.open(ContactDetailsModalComponent, {
      keyboard: false,
      backdrop: 'static',
    });

    modalRef.result.then((res: any) => {
      this.phoneNumber = res.phoneNumber;
      this.pricingHidden = false;
      this.updateBudgetQuote(res.phoneNumber, res.email);
    });
  }

  ngAfterViewInit(): void {
    if (this.activeTab === '3dModel' && this.viewerContainer) {
      this.initRenderer();
    }
  }

  private initializeRendererOptions(): void {
    this.options = new RendererOptions();
    this.options.allowDrag = true;
    this.options.allowSelection = false;
    this.options.allowTooltips = false;
    this.options.showCentreButton = true;
  }

  private updateBudgetQuote(phoneNumber: string, email: string): void {
    this.apollo
      .mutate<any>({
        mutation: updateBudgetQuote,
        variables: {
          budgetQuote: {
            id: this.budgetQuoteId,
            phoneNumber: phoneNumber,
            emailAddress: email,
          },
        },
      })
      .subscribe(({ data }) => {
        this.drawing = data.updateBudgetQuote.drawing;
        if (this.activeTab === '3dModel') {
          this.initRenderer();
        }
      });
  }

  switchTo3D(): void {
    setTimeout(() => {
      if (this.viewerContainer) {
        this.initRenderer();
      }
    }, 100); // Ensure tab switch before initializing
  }

  private initRenderer(): void {
    this.renderer = new Renderer({
      containerElement: this.viewerContainer.nativeElement,
      baseUrl: `/assets/models/`,
      onError: this.onRendererError,
    });

    if (this.renderer.canRender && this.drawing) {
      this.renderer.loadFloor(this.drawing);
    }
  }

  onRendererError = (error: ErrorEvent): void => {
    this.modalService.open(ErrorModalComponent).componentInstance.errorMessage =
      error.message;
  };

  private getBudgetDisclaimer(): Observable<string> {
    return this.settings.pipe(
      map((settings) => settings.get('budgetDisclaimer'))
    );
  }

  requestDistributorAccessClick(): void {
    this.modalService.open(RequestAccessModalComponent);
  }
}
